import { render } from "./IconMarker.vue?vue&type=template&id=fbd1a302"
import script from "./IconMarker.vue?vue&type=script&lang=js"
export * from "./IconMarker.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__